// src/services/storeAnalytics.js
import instance from "../axios";

export const getSMDSummary = async ({ dateFrom, dateTo, smdId } = {}) => {
  const params = {};

  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  if (smdId) params.smdId = smdId;

  const response = await instance.get(`analytics/smd/summary`, { params });
  return response.data;
};

export const getSummary = async () => {
  const response = await instance.get("analytics/stores/summary");
  return response.data;
};
export const getStockSummary = async () => {
  const response = await instance.get("analytics/stocks/summary");
  return response.data;
};
export const getDashboardMetrics = async () => {
  const response = await instance.get("analytics/dashboard/metrics");
  return response.data;
};

export const getMapDistribution = async () => {
  const response = await instance.get("analytics/stores/map-distribution");
  return response.data;
};
export const getVisitTrends = async (params) => {
  const response = await instance.get(`analytics/dashboard/visit-trends?period=${params}`);
  return response.data;
};
export const getMostVisitedStores = async () => {
  const response = await instance.get(`analytics/dashboard/most-visited-stores`);
  return response.data;
};

export const getGeographicDistribution = async () => {
  const response = await instance.get("analytics/geographic");
  return response.data;
};

export const getSalesPerformance = async () => {
  const response = await instance.get("analytics/performance");
  return response.data;
};

export const getStoreDetails = async (id) => {
  const response = await instance.get(`stores/${id}`);
  return response.data;
};

export const updateStore = async (id, data) => {
  const response = await instance.put(`stores/${id}`, data);
  return response.data;
};

export const createStore = async (data) => {
  const response = await instance.post("stores", data);
  return response.data;
};

export const deleteStore = async (id) => {
  const response = await instance.delete(`stores/${id}`);
  return response.data;
};

export const getStoreVisitations = async (storeId) => {
  const response = await instance.get(`stores/${storeId}/visitations`);
  return response.data;
};

export const getStoreStock = async (storeId) => {
  const response = await instance.get(`stores/${storeId}/stock`);
  return response.data;
};

export const getStorePerformanceMetrics = async (storeId) => {
  const response = await instance.get(`stores/${storeId}/metrics`);
  return response.data;
};

export const exportStoreData = async (params) => {
  const response = await instance.get("stores/export", {
    params,
    responseType: "blob", // Important for file downloads
  });
  return response.data;
};
